import {Modal, PrimaryButton, SecondaryButton} from 'components';
import React from 'react';
import FileImage from '../components/FileImage';

function RollbackVersion({open, setOpen, onClick, isLoading}) {
  return (
    <Modal
      show={open}
      onClose={() => setOpen(false)}
      extraModalClasses="max-w-[641px] w-full bg-white rounded-lg shadow-xl"
      modalPosition="fixed inset-0 flex items-center justify-center p-4"
      modalTitle="Rollback"
      contentPadding="!p-6"
    >
      <div className="max-w-[455px] mx-auto pt-12">
        <div
          className="w-[68px] h-[68px] rounded-full bg-[#EEF3FC] flex items-center justify-center
        mx-auto mb-6"
        >
          <FileImage />
        </div>
        <h1 className="text-[24px] text-[#080917] font-semibold text-center mb-4">
          Rollback flow version
        </h1>
        <p className="text-center text-body">
          This will rollback the version of this flow as another file and you
          will be able to make changes as you want
        </p>
      </div>
      <div className="flex items-center gap-4 justify-center flex-wrap mt-12 mb-6">
        <PrimaryButton
          onClick={onClick}
          buttonText="Rollback"
          className="w-[259px] !h-[52px]"
          loading={isLoading}
          disabled={isLoading}
        />
        <SecondaryButton
          onClick={() => setOpen(false)}
          buttonText="Cancel"
          className="!h-[52px] w-[259px] flex items-center justify-center !outline-[#DFE1E7] !text-[#033971] flex-row-reverse gap-1"
        />
      </div>
    </Modal>
  );
}

export default RollbackVersion;
